import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-412d7284"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cell-box xag-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title xag-flex-center" }, [
  /*#__PURE__*/_createTextVNode("报修设备"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" })
], -1))
const _hoisted_3 = { class: "content xag-flex" }
const _hoisted_4 = {
  key: 0,
  class: "explain-box"
}
const _hoisted_5 = { class: "cell auto-height" }
const _hoisted_6 = {
  class: "xag-flex-lr describe-header",
  style: {"margin-bottom":"13px"}
}
const _hoisted_7 = { class: "title xag-flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "设备故障照片", -1))
const _hoisted_9 = { class: "photo-requirement xag-flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "照片要求", -1))
const _hoisted_11 = { class: "cell auto-height" }
const _hoisted_12 = { class: "xag-flex-lr describe-header" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "故障描述", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title xag-flex-center" }, [
  /*#__PURE__*/_createTextVNode("维修网点"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" })
], -1))
const _hoisted_15 = { class: "xag-ellipsis" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title xag-flex-center" }, "回寄地址", -1))
const _hoisted_17 = { class: "text" }
const _hoisted_18 = {
  key: 1,
  class: "address-info"
}
const _hoisted_19 = { class: "xag-ellipsis" }
const _hoisted_20 = { class: "xag-ellipsis" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title xag-flex-center" }, "故障日志", -1))
const _hoisted_23 = {
  key: 0,
  class: "log-items"
}
const _hoisted_24 = { class: "explain-box" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title xag-flex-center" }, "购买凭证", -1))
const _hoisted_27 = { class: "explain-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_device_footer = _resolveComponent("device-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, { title: "故障报修" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "cell device-cell xag-flex-lr",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onViewDevices && _ctx.onViewDevices(...args)))
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_icon, { name: "arrow" }),
          _createElementVNode("div", null, "已选择（" + _toDisplayString(_ctx.cacheFaultDevices.length) + "个)", 1)
        ])
      ]),
      (_ctx.isHasFullInsurance)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 含保内设备，具体报修是否属于保内服务，将按照后续审核结果为准。 "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_van_icon, { name: "question-o" })
            ])
          ]),
          _createElementVNode("div", {
            class: "content no-val xag-flex",
            style: _normalizeStyle({ color: _ctx.fLen > 9 ? 'red' : '' })
          }, _toDisplayString(_ctx.fLen) + "/9 ", 5)
        ]),
        _createVNode(_component_van_uploader, {
          modelValue: _ctx.fileList,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fileList) = $event)),
          multiple: "",
          "max-count": 9,
          "before-delete": _ctx.beforeDelete,
          "after-read": _ctx.afterRead
        }, null, 8, ["modelValue", "before-delete", "after-read"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", {
            class: "content no-val xag-flex",
            style: _normalizeStyle({ color: _ctx.describeLen > 200 ? 'red' : '' })
          }, _toDisplayString(_ctx.describeLen) + "/200 ", 5)
        ]),
        _createVNode(_component_van_field, {
          style: {"font-size":"16px","line-height":"24px"},
          modelValue: _ctx.describe,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.describe) = $event)),
            _ctx.onSetDescribe
          ],
          modelModifiers: { trim: true },
          rows: "3",
          autosize: "",
          maxlength: "200",
          type: "textarea",
          placeholder: "请尽可能描述发生故障的情况，以便尽快解决问题。"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", {
        class: "cell xag-flex-lr",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onToSetPoint && _ctx.onToSetPoint(...args)))
      }, [
        _hoisted_14,
        _createElementVNode("div", {
          class: _normalizeClass(['content', 'xag-flex', { 'no-val': !_ctx.cacheNetworkpointName }]),
          style: {"width":"calc(100% - 98px)"}
        }, [
          _createVNode(_component_van_icon, { name: "arrow" }),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.cacheNetworkpointName || '请选择'), 1)
        ], 2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['cell', 'xag-flex-lr', { 'address-box': !_ctx.noHasAddress }]),
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onToSetAdress && _ctx.onToSetAdress(...args)))
      }, [
        _hoisted_16,
        _createElementVNode("div", {
          class: _normalizeClass(['content', 'xag-flex', { 'no-val': _ctx.noHasAddress }])
        }, [
          _createVNode(_component_van_icon, {
            name: "arrow",
            class: "address-icon"
          }),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.noHasAddress)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("请填写")
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.receiver) + " " + _toDisplayString(_ctx.phone), 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.address), 1)
                ]))
          ])
        ], 2)
      ], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cacheCompleteDevices, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.guid
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(['cell', 'device-cell', 'xag-flex-lr', { 'has-logs': item.logs?.length }]),
            onClick: ($event: any) => (_ctx.onToLogs(item))
          }, [
            _hoisted_22,
            _createElementVNode("div", {
              class: _normalizeClass(['content', 'xag-flex', { 'no-val': !item.logs?.length }])
            }, [
              _createVNode(_component_van_icon, { name: "arrow" }),
              _createElementVNode("div", null, _toDisplayString(item.logs?.length ? `已选择（${item.logs.length}个)` : '请选择'), 1)
            ], 2)
          ], 10, _hoisted_21),
          (item.logs?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.logs, (logItem) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "log-item xag-flex-lr",
                    key: logItem.guid
                  }, [
                    _createElementVNode("div", null, _toDisplayString(logItem.shortName.replace(/\-/g, '.')) + " " + _toDisplayString(logItem.startAtStr) + " ~ " + _toDisplayString(logItem.endAtStr), 1),
                    _createVNode(_component_van_icon, {
                      name: "cross",
                      onClick: ($event: any) => (_ctx.onDelLog(logItem))
                    }, null, 8, ["onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, "针对 “" + _toDisplayString(item.showName) + " 一 " + _toDisplayString(item.serial_number) + "”", 1)
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cacheComponents, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.guid
        }, [
          _createElementVNode("div", {
            class: "cell device-cell xag-flex-lr",
            onClick: ($event: any) => (_ctx.onFillVoucher(item))
          }, [
            _hoisted_26,
            _createElementVNode("div", {
              class: _normalizeClass(['content', 'xag-flex', { 'no-val': !(item.imgs?.length || item.describe) }])
            }, [
              _createVNode(_component_van_icon, { name: "arrow" }),
              _createElementVNode("div", null, _toDisplayString(item.imgs?.length || item.describe ? '已填写' : '请填写'), 1)
            ], 2)
          ], 8, _hoisted_25),
          _createElementVNode("div", _hoisted_27, "针对 “" + _toDisplayString(item.showName) + " 一 " + _toDisplayString(item.serial_number) + "”", 1)
        ]))
      }), 128))
    ]),
    _createVNode(_component_device_footer, {
      title: "立即提交",
      isCanClick: _ctx.isCanClick,
      onFooterSubmit: _ctx.onSubmitForm
    }, null, 8, ["isCanClick", "onFooterSubmit"])
  ], 64))
}